// extracted by mini-css-extract-plugin
module.exports = {"intro":"About-module--intro---0pWe","introInner":"About-module--intro-inner--1fQCf","image":"About-module--image--4Ww6G","mainContent":"About-module--main-content--Oc6R2"};